const PT = require("prop-types");
const React = require("react");
const WonkyButton = require("./WonkyButton");
const WhiteCardModal = require("./WhiteCardModal");
const AssetsUtil = require("../util/AssetsUtil");
const CopyTable = require("../util/CopyTable");
const Sounds = require("../util/Sounds");

const styles = require("./styles/StartTestModal.css");

// Chapter test start confirmation; GlobalModal uses this instead of ChooseOptionModal for eligible family students.
function StartTestModal(props) {
	const {
		gradeNumber,
		chapter,
		styleType,
		isRepeat,
		isLastChapterInLevel,
		isFinalAcademyTest,
		onConfirm,
		onNotConfirm,
		onClose,
		fillColor,
		shadowColor,
	} = props;

	const copy = CopyTable.forChapterTestStartModal({
		baLevel: gradeNumber,
		chapter,
		isRepeat,
		isLastChapterInLevel,
		isFinalAcademyTest,
	});

	const musicTrackToRestoreRef = React.useRef(null);

	React.useEffect(() => {
		musicTrackToRestoreRef.current = Sounds.getCurrentMusicTrackName();
		Sounds.stopMusic(false);
		Sounds.playSound("test-start");
	}, []);

	const resumeMusicThen = React.useCallback(callback => {
		const track = musicTrackToRestoreRef.current;
		if (track) {
			Sounds.playMusic(track);
		}
		callback();
	}, []);

	const bannerText = `Chapter ${chapter}: Test`;

	return (
		<WhiteCardModal
			onClose={() => resumeMusicThen(onClose)}
			styleType={styleType}
			fillColor={fillColor}
			shadowColor={shadowColor}
			title={copy.title}
			subtext={copy.subtext}
			buttons={
				<>
					<WonkyButton
						className={WhiteCardModal.BUTTON_CLASS}
						handleClick={() => resumeMusicThen(onNotConfirm)}
						buttonType={copy.buttonTypes[1]}
						variant="outline"
					/>
					<WonkyButton
						className={WhiteCardModal.BUTTON_CLASS}
						handleClick={onConfirm}
						buttonType={copy.buttonTypes[0]}
					/>
				</>
			}
		>
			<div className={styles.illustrationWrap}>
				<img
					src={AssetsUtil.getStartTestIllustration()}
					className={styles.illustration}
					aria-hidden="true"
				/>
				<span className={styles.bannerText}>{bannerText}</span>
			</div>
		</WhiteCardModal>
	);
}

StartTestModal.displayName = "StartTestModal";

StartTestModal.propTypes = {
	gradeNumber: PT.number.isRequired,
	chapter: PT.number,
	chapterName: PT.string,
	styleType: PT.string,
	isRepeat: PT.bool,
	isLastChapterInLevel: PT.bool,
	isFinalAcademyTest: PT.bool,
	onConfirm: PT.func.isRequired,
	onNotConfirm: PT.func.isRequired,
	onClose: PT.func.isRequired,
	fillColor: PT.string,
	shadowColor: PT.string,
};

module.exports = StartTestModal;
